<tui-hosted-dropdown [content]="content" [canOpen]="isMobileRes$ | async | isFalse">
  <div id="account-avatar">
    <ng-content/>
  </div>
</tui-hosted-dropdown>
<ng-template #content let-activeZone>
  <tui-data-list
    tuiDataListDropdownManager
    [size]="'s'"
    [tuiActiveZoneParent]="activeZone"
  >
    <button
      data-e2e="account button"
      tuiOption
      (click)="goToAccount.emit()"
    >{{ 'Account' }}</button>
    <button
      *ngIf="canSeeSwitchContextPage"
      data-e2e="switch-context button"
      tuiOption
      (click)="goToContext.emit()"
    >{{ 'Switch Context' }}</button>
    <button
      *ngIf="impersonateContext?.withImpersonation"
      data-e2e="impersonation button"
      tuiOption
      (click)="impersonation.emit()"
    >{{ impersonateContext!.label | translate }}</button>
    <button
      data-e2e="logout button"
      tuiOption
      (click)="logout.emit()"
    >{{ 'auth.logout' | translate }}</button>
  </tui-data-list>
</ng-template>
